import { create } from 'zustand'

import { UserApplicationAccountUserPaginated } from '../hooks/usePaginateUserApplicationAccountUser'

interface SelectedSelectedUserApplicationAccountUserStore {
  userAccess: UserApplicationAccountUserPaginated | null
  toggleSelectedUserAccess: (
    user: UserApplicationAccountUserPaginated | null,
  ) => void
}

export const useSelectedUserApplicationAccountUserStore =
  create<SelectedSelectedUserApplicationAccountUserStore>((set) => ({
    userAccess: null,
    toggleSelectedUserAccess: (userAccess) => set({ userAccess }),
  }))
